export default __webpack_public_path__ + "static/terminal_groove-d6f058af81ce6f972239ce7646080ef1.png";